import { createApi } from '@reduxjs/toolkit/query/react';

import { apiTablePreferences } from '~constants/api';

import { rtkBaseQueryWrapper } from '~libs/axiosWrapper';

// A bare mutation with no matching query in this API: the backend now resolves each column's
// current visibility directly on the specs response (see useColumnVisibility), so nothing here
// needs to read this store back - it only ever needs to write to it.
export const userTablePreferencesApi = createApi({
  reducerPath: 'userTablePreferencesApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiTablePreferences }),
  endpoints: (builder) => ({
    upsertTablePreferences: builder.mutation<void, { tableKey: string; visibleColumnIds: string[] }>({
      query: ({ tableKey, visibleColumnIds }) => ({
        url: `/${tableKey}`,
        method: 'PUT',
        body: { visibleColumnIds },
      }),
    }),
  }),
});

export const { useUpsertTablePreferencesMutation } = userTablePreferencesApi;
